export default __webpack_public_path__ + "static/media/Trip Management.596737d2.svg";